import React, { Component } from "react";
import CommonTemplate from "./commonTemplate";
import { QueryAssistant } from "../home/home";
import Signbutton from "../forms/button";
import { Input } from "../forms/input";
import { connect } from "react-redux";
import { forgotUserId } from "../../store/actions";
import CustomizedDialogs from "../home/customModal";

class ForgotUserId extends Component {
  constructor(props) {
    super(props);
    this.state = {
      emailId: { value: "" },
      open: false,
    };
  }
  closeModal = () => {
    this.setState({
      open: false,
    });
    this.props.history.push("/");
  };

  keyPress = (e) => {
    if (e.key === "Enter") {
      this.sendUserId();
      e.preventDefault();
    }
  };

  changeValue = (event) => {
    this.setState({
      emailId: { value: event.target.value },
    });
  };

  // showError = () => {
  //   const {
  //     emailId: { value }
  //   } = this.state;
  //   this.setState({
  //     emailId: {
  //       value,
  //       isError:
  //         !value || !/^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/.test(value),
  //       errorMessage: !value ? "is required" : "Please enter valid EmailId"
  //     }
  //   });
  // };

  sendUserId = async () => {
    const {
      emailId: { value },
    } = this.state;

    if (!value) {
      this.emailIdField.focus();
      this.setState({
        emailId: {
          value,
          isError: !value,
          errorMessage: "Email Id is mandatory",
        },
      });
    } else if (!/^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/.test(value)) {
      this.setState({
        emailId: {
          value: "",
          isError: true,
          errorMessage: "Please enter a valid email ID",
        },
      });
    } else {
      const params = {
        ReqBy: "a",
        Emailid: value,
        customfund: "189",
      };
      const response = await this.props.forgotUserId(params);
      if (!response) {
        this.setState({
          emailId: {
            value: "",
            isError: true,
            errorMessage: "Email ID is required to proceed",
          },
        });
        return;
      } else if (response) {
        this.setState({ open: true, emailId: { value: "" } });
      }
    }
  };

  render() {
    const { emailId } = this.state;
    return (
      <CommonTemplate
        title="Forgot User ID"
        textOne="Please enter your Registered Email Id"
        textTwo=""
      >
        {/* <QueryAssistant /> */}
        <Input
          maxLength={50}
          name="Email ID"
          value={emailId.value}
          bordercolor="#a6a6a6"
          onChange={this.changeValue}
          onBlur={this.showError}
          errorMessage={emailId.errorMessage}
          isShowError={emailId.isError}
          inputref={(ele) => (this.emailIdField = ele)}
          onKeyPress={this.keyPress}
        />
        <Signbutton buttontitle="Submit" onClick={this.sendUserId} />
        <CustomizedDialogs
          open={this.state.open}
          closeModal={this.closeModal}
          passwordSucess={true}
          message={
            "Your UserId has been sent to your Email Id and Mobile number"
          }
        />
        <div className="ReturntoSignin">
          <button
            className="login-no-account-span1 mouse-pointer border-0"
            onClick={() => this.props.history.push("/login")}
          >
            Return to Sign-in
          </button>
        </div>
      </CommonTemplate>
    );
  }
}

export default connect(null, { forgotUserId })(ForgotUserId);
